
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TimeFrameOption, validateTimeFrame } from '@/components/business/leads/utils/dateFilters';

interface NavBarTimeFrameProps {
  timeFrame: TimeFrameOption | string;
  onTimeFrameChange?: (value: TimeFrameOption) => void;
  isMobile?: boolean;
}

export const NavBarTimeFrame: React.FC<NavBarTimeFrameProps> = ({
  timeFrame,
  onTimeFrameChange,
  isMobile = false
}) => {
  // Handle value change and validate it
  const handleValueChange = (value: string) => {
    if (onTimeFrameChange) {
      // Ensure the value is a valid TimeFrameOption
      const validTimeFrame = validateTimeFrame(value);
      onTimeFrameChange(validTimeFrame);
    }
  };

  return (
    <Select value={timeFrame} onValueChange={handleValueChange}>
      <SelectTrigger 
        className={`h-10 flex items-center justify-between py-2 ${isMobile ? "w-full" : "w-[160px]"}`}
      >
        <SelectValue>{timeFrame}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="Past 7 days">Past 7 days</SelectItem>
        <SelectItem value="Past 30 days">Past 30 days</SelectItem>
        <SelectItem value="Past 90 days">Past 90 days</SelectItem>
        <SelectItem value="Past year">Past year</SelectItem>
        <SelectItem value="All time">All time</SelectItem>
      </SelectContent>
    </Select>
  );
};
